import { useEffect, useRef, useState } from "react";

// Assets & constants used across sections
export const BRAND = {
  name: "Har Ghar Strength",
  tagline: "Strength can be built anywhere.",
  whatsapp: "918586873016",
  whatsappDisplay: "+91 85868 73016",
  email: "hargharstrength@gmail.com",
  instagram: "hargharstrength",
  linkedin: "https://www.linkedin.com/in/aditya-kulhari-8822b11a5?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  logo: "/images/logo.jpg",
  coach: "/images/coach.jpg",
  hero: "/images/hero.jpg",
  outdoor: "/images/hero.jpg",
  indoor: "/images/hero.jpg",
};

export const buildWhatsAppUrl = (message) => {
  const base = `https://wa.me/${BRAND.whatsapp}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

// Reveal-on-scroll wrapper
export function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`reveal ${seen ? "in" : ""} ${className}`}
    >
      {children}
    </Tag>
  );
}
